import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../../components/Styled/Misc';
import { Button } from '../../../components/Styled/Buttons';
import ListerSelectors from '../../../const/listers_selectors';

const ShemaSelector = ListerSelectors.cat.schema.selector;

function SelectSchemaButton({ content, onSelect }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        content={content}
        onClick={() => setShow(true)}
      />
      <Modal open={show}>
        <ShemaSelector
          selectMode
          onChoice={(e, v) => {
            onSelect(v.id);
            setShow(false);
          }}
          onClose={() => setShow(false)}
        />
      </Modal>
    </>
  );
}

SelectSchemaButton.propTypes = {
  content: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

SelectSchemaButton.defaultProps = {
  content: null,
};

export default SelectSchemaButton;
